import { httpDispatcher } from './httpDispatcher';

const METASITE_APP_ID = -666;

export const fetchAppReadme = httpDispatcher<[{ id: string; version: string }]>(
  ({ editorAPI, baseUrl }, { id, version }) => {
    return {
      buildUrl: () =>
        `${baseUrl}/v1/packages/${id}/files/readme?version=${version}`,
      buildSiHeader: () =>
        editorAPI.dsRead.platform.getAppDataByApplicationId(METASITE_APP_ID)
          .instance,
    };
  },
);
